import { guestRoutes } from "./apiRouteLists/guest-route-lists";
import { loggedRoutes } from "./apiRouteLists/logged-route-lists";

const apiRouteList = {
    loggedRoutes: loggedRoutes,
    guestRoutes: guestRoutes
}

export default apiRouteList;